import { useState, useCallback } from 'react';

type NameMap = Record<string, Record<string, string>>;

export function useLookupNames() {
  const [names, setNames] = useState<NameMap>({});

  const setName = useCallback((category: string, key: string, value: string) => {
    setNames((prev) => ({
      ...prev,
      [category]: { ...(prev[category] ?? {}), [key]: value },
    }));
  }, []);

  const getName = useCallback(
    (category: string, key: string): string => names[category]?.[key] ?? '',
    [names]
  );

  const clearNames = useCallback(() => setNames({}), []);

  return { names, setName, getName, clearNames };
}
